<template>
  <div class="col-md-4">
    <ul class="media-kit-menu">
      <li :class="{ active: currentRoute === 'media-kit-brand-guideline' }">
        <router-link to="/media-kit-brand-guideline">BRAND GUIDELINE</router-link>
      </li>
      <li :class="{ active: currentRoute === 'media-kit-visual-elements' }">
        <router-link to="/media-kit-visual-elements">MEDIA GALLERY</router-link>
      </li>
      <li :class="{ active: currentRoute === 'media-kit-sharing-templates' }">
        <router-link to="/media-kit-sharing-templates">SHARING TEMPLATES</router-link>
      </li>
      <li :class="{ active: currentRoute === 'media-kit-written-content' }">
        <router-link to="/media-kit-written-content">WRITTEN CONTENT</router-link>
      </li>
      <li :class="{ active: currentRoute === 'useful-resources' }">
        <router-link to="/useful-resources">USEFUL GUIDES</router-link>
      </li>
    </ul>
    <div class="helpBtn">
      <a href="https://help.b1g1.com/collection/1-members">
        <img src="/static/front/images/question-icon.svg" alt="alt">
        B1G1 Help Centre
      </a>
      <a v-if="companyStrategyDetails.url && companyStrategyDetails.status === 'active'"
         :href="companyStrategyDetails.url" target="_blank">
        <img src="/static/front/images/strategy-document-icon.svg" alt="alt">
        Your Strategy Document
      </a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import strategyDocumentAPI from '../../../api/strategyUrl'

export default {
  props: {
    companyId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      companyStrategyDetails: {}
    }
  },
  computed: {
    currentRoute () {
      return this.$route.path.split('/').pop()
    }
  },
  methods: {
    getStrategyUrl (companyId) {
      strategyDocumentAPI
        .get({ company_id: companyId })
        .then((response) => {
          if (response && response.data) {
            this.companyStrategyDetails = response.data
          }
        })
        .catch((error) => {
          console.error('Error fetching strategy URL:', error)
          Vue.$notify('An error occurred while fetching the strategy URL.', 'error')
        })
    }
  },
  created () {
    this.getStrategyUrl(this.companyId)
  }
}
</script>

<style scoped>
.media-kit-menu .active {
  font-weight: bold;
}

.media-kit-menu a {
  font-size: 22px;
  font-weight: 300;
  font-family: "Brandon Grotesque";
}

.media-kit-menu li {
  margin-bottom: 40px;
  padding-left: 25px;
  position: relative;
}

.media-kit-menu li.active:before {
  content: "";
  position: absolute;
  width: 8px;
  height: 50px;
  background: #30B5EA;
  left: 0;
  top: -10px;
}

.media-kit-menu li.active a {
  font-weight: 600;
}

.helpBtn a {
    display: inline-block;
    border: 2px solid #B8B8B8;
    padding: 5px;
    border-radius: 5px;
    font-size: 15px;
    font-weight: 500;
    color: #171733;
    background: #F9F9F9;
    margin: 0 0 15px;
    max-width: 215px;
    width: 100%;
    text-align: center;
}
.helpBtn a:hover{
  background: #171733;
  color: #fff;
}
.helpBtn a img {
    filter: contrast(0) brightness(0);
    margin: -4px 3px 0 0px;
}
.helpBtn a:hover img {
  filter: contrast(1) brightness(100);
}
.helpBtn {
    margin-left: 25px;
}

@media screen and (max-width: 991px) {
  .media-kit-menu li {
    margin-bottom: 30px;
  }
  .media-kit-menu a {
    font-size: 17px;
  }
  .media-kit-menu li.active::before {
    height: 30px;
    top: -3px;
  }
  .helpBtn{
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/business/connect/MediaKitMenu.vue